import { Button, Empty, message, Spin } from 'antd';
import MachineCard from '../../../components/machineCard';
import { useNavigate } from 'react-router';
import { ListContainer } from './styles';
import ActionHeader from '../../../components/actionHeader';
import Page from '../../../components/page';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  fetchMachines,
  selectIsFetchingMachine,
  selectMachines,
  setMachines,
} from '../../../slices/machines';
import { useAppDispatch } from '../../../store';
import { useTranslation } from 'react-i18next';
import { deleteMachine } from '../../../utils/httpRequest';

const MachineList = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [search, setSearch] = useState<string>();

  const machines = useSelector(selectMachines);
  const isFetchingMachines = useSelector(selectIsFetchingMachine);
  const [loadingMachineIds, setLoadingMachineIds] = useState<string[]>([]);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    dispatch(fetchMachines({ search }));
  }, []);

  const handleMachineClick = (id: string) => {
    navigate(`${id}`);
  };

  const handleMachineEdit = (id: string) => {
    navigate(`${id}/edit`);
  };

  const handleMachineDelete = async (id: string) => {
    try {
      setLoadingMachineIds([...loadingMachineIds, id]);
      await deleteMachine(id);
      dispatch(setMachines(machines.filter((i) => i.machineID !== id)));
    } catch (err: any) {
      messageApi.error(err?.message || 'Delete Failed!');
    } finally {
      setLoadingMachineIds(loadingMachineIds.filter((i) => i !== id));
    }
  };

  const handleAddClick = () => {
    navigate('add');
  };

  const handleSearch = (searchText?: string) => {
    setSearch(searchText);
    if (!isFetchingMachines) {
      dispatch(
        fetchMachines({
          search: searchText,
        })
      );
    }
  };

  return (
    <Page
      header={
        <ActionHeader
          title={t('machine_all_machines')}
          titleTag={`(${machines.length})`}
          showSearch
          onSearch={handleSearch}
          endSlot={
            <>
              {/* <Button type="primary" ghost onClick={handleAddClick}>
                {t('batchUpload')}
              </Button> */}
              <Button type="primary" onClick={handleAddClick}>
                {t('machine_add_new')}
              </Button>
            </>
          }
        />
      }
    >
      {contextHolder}
      {isFetchingMachines ? (
        <Spin size="large" style={{ marginTop: 100 }} />
      ) : (
        <ListContainer direction="vertical" size={16}>
          {machines.length ? (
            machines.map((item) => (
              <Spin
                spinning={loadingMachineIds.includes(item.machineID)}
                key={item.machineID}
              >
                <MachineCard
                  data={item}
                  onClick={handleMachineClick}
                  onEdit={handleMachineEdit}
                  onDelete={handleMachineDelete}
                />
              </Spin>
            ))
          ) : (
            <Empty style={{ paddingTop: 80 }} />
          )}
        </ListContainer>
      )}
    </Page>
  );
};

export default MachineList;
